<template>
  <div class="pc-page__login">
    <div class="pc-page__login-container">
      <div class="pc-page__login-logo">
        <!-- <avatar :size="100"/> -->
        Peacock
      </div>
      <div class="pc-page__login-form">
        <div class="item">
          <el-input v-model="email" placeholder="邮箱" clearable/>
        </div>
        <div class="item">
          <el-input type="password" v-model="password" placeholder="密码" clearable/>
        </div>
        <div class="item">
          <el-button type="primary" style="width:100%" :disabled="loading" @click="loginHandler">登 录</el-button>
        </div>
      </div>
    </div>
    <div class="pc-page__login-footer">
      <!-- &copy; {{year}} yujunyang.com -->
      Powered by <a href="" target="_blank">Peacock 0.1.0</a>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { isEmail, isPassword, isNullOrWhiteSpace } from '@/common/utils'
import { mapActions } from 'vuex'
import { operateError } from '@/common/errors'
// import Avatar from '@/components/avatar/Avatar.vue'

export default {
  components: {
    // Avatar
  },
  data () {
    return {
      email: '',
      password: '',
      loading: false
    }
  },
  async mounted () {
    const authenticated = await this.checkLogin()
    if (authenticated) {
      let returnUrl = this.$route.query.returnUrl
      if (isNullOrWhiteSpace(returnUrl)) {
        returnUrl = '/'
      }
      this.$router.replace(returnUrl)
    }
  },
  computed: {
    year () {
      return dayjs().year()
    }
  },
  methods: {
    ...mapActions('auth', {
      login: 'login',
      checkLogin: 'check'
    }),
    async loginHandler () {
      const email = (this.email || '').trim()
      const password = (this.password || '').trim()
      if (!isEmail(email)) {
        this.$message({
          message: '邮箱格式无效',
          type: 'warning'
        })
        return
      }
      if (!isPassword(password)) {
        this.$message({
          message: '密码格式无效',
          type: 'warning'
        })
        return
      }
      try {
        this.loading = true
        await this.login({ email, password })
        this.$message({
          message: '登录成功',
          type: 'success'
        })
        let returnUrl = this.$route.query.returnUrl
        if (isNullOrWhiteSpace(returnUrl)) {
          returnUrl = '/'
        }
        this.$router.replace(returnUrl)
      } catch (e) {
        operateError(e, '登录')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-page__login {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.pc-page__login-container {
  width: 30rem;
  height: 0;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.pc-page__login-logo {
  font-size: 3rem;
  color: $color-main;
  text-align: center;
  .pc-avatar {
    margin: auto;
  }
}
.pc-page__login-footer {
  padding: 5rem 0 3rem 0;
  color: $color-b3;

  a {
    text-decoration: none;
    color: $color-b3;
    font-weight: bold;
  }

  a:hover {
    text-decoration: underline;
  }
}
.pc-page__login-form {
  margin-top: 6rem;

  .item {
    margin-bottom: 1.5rem;
  }
  .item:last-of-type {
    margin-top: 3.5rem;
  }
}
</style>
